import { fieldNameMaps } from "./fieldNameMaps";
import { transformBooleanField } from "./valuenamemaps";
import { resolveFieldValue } from "./clsnamemaps";

const excludePrefixes = [
  'InsertParamList', 'UpdateParamList', 'DeleteParamList',
  'LastUpdateUserName', 'LastUpdateDate', 'RegionName', 'AccidentCommUid'
];

export async function processLogDiffs(logs, methodName) {
  if (!logs || logs.length < 2) return [];

  const normalizedFieldNames = {};
  for (const key in fieldNameMaps) {
    normalizedFieldNames[key.toLowerCase()] = fieldNameMaps[key];
  }

  const result = [];

  for (let i = 0; i < logs.length - 1; i++) {
    const current = { ...(logs[i].RequestData || {}) };
    const prev = { ...(logs[i + 1].RequestData || {}) };

    const changes = [];

    for (const key of Object.keys(current)) {
      if (excludePrefixes.some(prefix => key.startsWith(prefix))) continue;

      let currentVal = transformBooleanField(key, current[key]);
      let prevVal = transformBooleanField(key, prev[key]);

      if (JSON.stringify(currentVal) !== JSON.stringify(prevVal)) {
        currentVal = await resolveFieldValue(key, currentVal);
        prevVal = await resolveFieldValue(key, prevVal);

        const lowerKey = key.toLowerCase();
        const displayName = normalizedFieldNames[lowerKey] || key;

        changes.push({
          key,
          keyDisplay: displayName,
          current: currentVal,
          prev: prevVal || ''
        });
      }
    }

    if (changes.length > 0) {
      result.push({
        timestamp: logs[i].Timestamp,
        method: logs[i].MethodName,
        changes
      });
    }
  }

  return result;
}
